import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Link } from '@beef/ui-kit';
import { LayoutTariffsContainer } from '@beef/smart-kit';
import { Title } from "./..";
import styles from "./styles.module.pcss";
import { Tariff } from "./Tariff";
var cx = classNames.bind(styles);
var LayoutTariffs = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    seeAllLink = _ref.seeAllLink,
    seeAllLinkText = _ref.seeAllLinkText,
    withNavigation = _ref.withNavigation,
    _ref$tariffs = _ref.tariffs,
    tariffs = _ref$tariffs === void 0 ? [] : _ref$tariffs,
    _ref$blockIndex = _ref.blockIndex,
    blockIndex = _ref$blockIndex === void 0 ? 0 : _ref$blockIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('title-wrapper'),
    "data-t-id": "components-LayoutTariffs"
  }, title && /*#__PURE__*/React.createElement(Title, null, title), seeAllLink && /*#__PURE__*/React.createElement("div", {
    className: cx('link')
  }, /*#__PURE__*/React.createElement(Link, {
    extraAttributes: {
      rel: 'noreferrer nofollow'
    },
    href: seeAllLink,
    isNoUnderline: true,
    size: "size4-m",
    target: "_blank"
  }, seeAllLinkText || 'Посмотреть все'))), /*#__PURE__*/React.createElement(LayoutTariffsContainer, {
    enabledCarouselLength: 3,
    isCarouselEnabled: true,
    tariffLength: tariffs.length,
    withNavigation: withNavigation
  }, tariffs.map(function (tariff, i) {
    return /*#__PURE__*/React.createElement(Tariff, _extends({}, tariff, {
      blockIndex: blockIndex,
      cardType: tariffs.length === 1 ? 'max' : 'default',
      index: i,
      key: tariff.id
    }));
  })));
});
export { LayoutTariffs };